import { render, staticRenderFns } from "./SelectWalletExpansionPanel.vue?vue&type=template&id=04c9ba68&scoped=true"
import script from "./SelectWalletExpansionPanel.js?vue&type=script&lang=js&external"
export * from "./SelectWalletExpansionPanel.js?vue&type=script&lang=js&external"
import style0 from "./SelectWalletExpansionPanel.vue?vue&type=style&index=0&id=04c9ba68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9ba68",
  null
  
)

export default component.exports